import React, { useState, useContext } from 'react';
import axios from 'axios';
import AppContext from '../../../Context/AppContext';
import SelectedOneGoalConfirm from './TemplateGoals/SelectedOneGoalConfirm';
import './OolaOneSectionSelect.css';
import configData from '../../../config.json';

const SelectOneSectionConfirm = (props) => {
    const { checkUserSession, changeLoading } = useContext(AppContext);
    const currUser = checkUserSession();
    const [selectedOolaOne, ChangeselectedOolaOne] = useState(() =>
        (props.AllState.SelectedGoalsSeven || []).some(
            (goal) => goal.selectedOne === true
        )
            ? 1
            : 0
    );

    const hasSelection =
        selectedOolaOne === 1 ||
        (props.AllState.SelectedGoalsSeven || []).some(
            (goal) => goal.selectedOne === true
        );

    function selectOolaOneGoal(indexF, itemF) {
        for (let i = 0; i < props.AllState.SelectedGoalsSeven.length; i++) {
            props.AllState.SelectedGoalsSeven[i].selectedOne = false;
        }
        props.AllState.SelectedGoalsSeven[indexF].selectedOne = true;
        if (currUser.userStepId != 7) props.handleChangeHeader(1);

        props.AllState.SelectedOolaOne = itemF;
        props.AllState.changeData(props.AllState);
        props.forceUpdate();
        ChangeselectedOolaOne(1);
    }

    function finishSelectOolaOne() {
        if (selectedOolaOne === 1) {
            const OolaOneItem = props.AllState.SelectedGoalsSeven.find(
                (x) => x.selectedOne === true
            );
            changeLoading(true);
            const url = `${configData.SERVER_URL}Goals/SetOolaOne/${OolaOneItem.GoalId}`;
            axios
                .put(
                    url,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${currUser.token}`,
                        },
                    }
                )
                .then(() => {
                    changeLoading(false);
                    props.changeStep();
                })
                .catch((error) => {
                    console.log(error);
                    changeLoading(false);
                });
        } else {
            alert('Select your Oola one');
        }
    }

    return (
        <div className="selectOolaOne__container">
            <div className="RecomendationTitleOne">
                SELECT YOUR OOLA ONE GOAL:
            </div>
            <div className="RecomendationDescOne">
                Choose the one goal you want to focus on most over the next 365
                days.
            </div>
            <ul
                className="selectOolaOne__goalList"
                role="radiogroup"
                aria-label="Select your Oola One goal"
            >
                {props.AllState.SelectedGoalsSeven.map((itemF, indexF) => {
                    const fMeta = props.AllState.Fs?.[itemF.areaId] || {
                        name: 'Goal',
                        color: '#15C184',
                    };
                    return (
                        <li key={indexF}>
                            <SelectedOneGoalConfirm
                                selectOolaOneGoal={selectOolaOneGoal}
                                updateIndexStep2={props.updateIndexStep2}
                                changeData={props.changeData}
                                AllState={props.AllState}
                                itemF={itemF}
                                indexF={indexF}
                                hideNav={false}
                                Fs={fMeta}
                            />
                        </li>
                    );
                })}
            </ul>
            <div className="selectOolaOne__footer">
                <p className="selectOolaOne__helper" aria-live="polite">
                    {hasSelection
                        ? 'Your Oola One Goal is selected.'
                        : 'Select one goal to continue.'}
                </p>
                <button
                    type="button"
                    className={`btnNextStep2One selectOolaOne__continue${
                        hasSelection ? ' selectOolaOne__continue--ready' : ''
                    }`}
                    disabled={!hasSelection}
                    onClick={() => finishSelectOolaOne()}
                >
                    CONTINUE {'>'}
                </button>
            </div>
        </div>
    );
};

export default SelectOneSectionConfirm;
